import { Camera, ArrowLeftRight } from 'lucide-react'
import { cn } from '@/lib/utils'

export type BannerFormat = 'poster' | 'instagram'

export interface BannerUploadOptionsProps {
  isLoading?: boolean
  bannerInputRef?: React.RefObject<HTMLInputElement | null>
}

export function BannerUploadOptions({ 
  isLoading = false,
  bannerInputRef 
}: BannerUploadOptionsProps) {
  const handlePosterClick = () => {
    // Store format and trigger file input
    if (bannerInputRef?.current) {
      bannerInputRef.current.dataset.format = 'poster'
      bannerInputRef.current.click()
    }
  }

  const handleSquareClick = () => {
    // Store format and trigger file input
    if (bannerInputRef?.current) {
      bannerInputRef.current.dataset.format = 'instagram'
      bannerInputRef.current.click()
    }
  }

  return (
    <div className="w-full pb-2">
      <div className="flex flex-col items-center gap-6">
        <div className="flex items-center justify-center gap-6">
          {/* Poster Option */}
          <div className="flex flex-col items-center gap-3">
            <button
              onClick={handlePosterClick}
              disabled={isLoading}
              type="button"
              className={cn(
                "bg-primary hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed",
                "rounded-lg p-3 transition-all flex flex-col items-center justify-center gap-1.5",
                "aspect-[9/16] w-20 text-white"
              )}
            >
              <Camera className="w-5 h-5" />
              <span className="text-[10px] font-medium">Add</span>
            </button>
            <div className="text-center">
              <p className="text-xs font-medium text-foreground">Poster</p>
              <p className="text-[10px] text-muted-foreground">9:16</p>
              <p className="text-[10px] text-muted-foreground">A4</p>
            </div>
          </div>

          {/* Divider */}
          <ArrowLeftRight className="w-5 h-5 text-muted-foreground" />

          {/* Square Option */}
          <div className="flex flex-col items-center gap-3">
            <button
              onClick={handleSquareClick}
              disabled={isLoading}
              type="button"
              className={cn(
                "bg-primary hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed",
                "rounded-lg p-3 transition-all flex flex-col items-center justify-center gap-1.5",
                "aspect-[1/1] w-20 text-white"
              )}
            >
              <Camera className="w-5 h-5" />
              <span className="text-[10px] font-medium">Add</span>
            </button>
            <div className="text-center">
              <p className="text-xs font-medium text-foreground">Square</p>
              <p className="text-[10px] text-muted-foreground">1:1</p>
              <p className="text-[10px] text-muted-foreground">1080 × 1080 px</p>
            </div>
          </div>
        </div>

        {/* Flexibility Note */}
        <p className="text-[10px] text-muted-foreground text-center max-w-xs">
          Anything in between these aspect ratios works too!
        </p>
      </div>
    </div>
  )
}
